export function clone<T>(object: T): T {
    if (object instanceof Array) {
        const item = Array.from<T>(object);

        item.forEach((value, index) => {
            item[ index ] = clone(item[ index ]);
        });

        return <any>item;
    }

    if (typeof object === 'object') {
        const item = Object.assign(Object.create(<any>object), object);

        Object.keys(item).forEach((property: string) => {
            if (item[ property ] instanceof Array || typeof item[ property ] === 'object') {
                item[ property ] = clone(item[ property ]);
            }
        });

        return item;
    }

    return object;
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/clone.function.ts